import { Role } from "../models/User";
import axiosInstance from "./axiosInstance";

export enum RoleEnum {
  SUPER_ADMIN = "SUPER_ADMIN",
  ADMIN = "ADMIN",
  OWNER = "OWNER",
  USER = "USER",
  CUSTOMER = "CUSTOMER",
  ENTREPRISE = "ENTREPRISE",
}

const getAllRoles = async () => {
  const response = await axiosInstance.get("role/all");
  return response.data;
};

const createRole = async (data: Role) => {
  const response = await axiosInstance.post("role/create", data);
  return response.data;
};

const updateRole = async (data: Role) => {
  const response = await axiosInstance.patch("role/update", data);
  return response.data;
};

const getRoleById = async (roleId: string) => {
  const response = await axiosInstance.get(`role/${roleId}`);
  return response.data;
};

export const rolesService = {
  getAllRoles,
  createRole,
  updateRole,
  getRoleById
};
